import { AfterViewInit, Component, OnInit, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { State } from '../shared/core/state';
import { Router } from '@angular/router';
import { Pagination } from '../shared/models/pagination.model';
import { LiveClass } from '../shared/core/state/live-class/models/live-class';
import * as LiveClassActions from '../shared/core/state/live-class/live-class.action';
import { SubscriptionStatus } from '../shared/core/state/subscription/subscription.model';
import { FormatterService } from '../shared/util/formatter.service';
import { toLiveClassCardViewModel } from '../shared/util/ui-card.mapper';
import { UiCardViewModel } from '@black/ui';

@Component({
  selector: 'black-live-classes',
  templateUrl: './live-classes.component.html',
  styleUrl: './live-classes.component.css',
  standalone: false,
})
export class LiveClassesComponent implements OnInit {
  private store = inject<Store<State>>(Store);
  private router = inject(Router);
  private formatter = inject(FormatterService);

  liveClasses: LiveClass[] = [];
  liveClassCards: UiCardViewModel[] = [];
  pagination: Pagination = {
    totalDocs: 0,
    limit: 0,
    totalPages: 0,
    page: 0,
    pagingCounter: 0,
    hasPrevPage: false,
    hasNextPage: false,
    prevPage: 0,
    nextPage: 0,
  };

  totalPagesRange: number[] = [];

  ngOnInit(): void {
    this.store.dispatch(LiveClassActions.fetchAllLiveClasses({ page: 1 }));

    this.store
      .select((state) => state.liveClass.liveClassItems)
      .subscribe((items) => {
        this.liveClasses = items;
        this.liveClassCards = items.map((item) =>
          toLiveClassCardViewModel(item, this.formatter, {
            isEnrolled: this.hasValidSubscription(item),
            submitButtonText: 'Subscribe Now',
          })
        );
      });

    this.store
      .select((state) => state.liveClass.pagination)
      .subscribe((result) => {
        this.pagination = result;
        this.totalPagesRange = new Array(
          this.pagination.totalPages <= 0 ? 0 : this.pagination.totalPages - 1
        );
      });
  }

  createRange(length: number, currentPage: number) {
    return new Array(length).fill(0).map((n, index) => index + 1);
  }

  paginateItems(page: number) {
    this.store.dispatch(LiveClassActions.fetchAllLiveClasses({ page }));
  }

  onClickLiveClass(id: string) {
    this.router.navigate(['live-classes', id]);
  }

  onClickSubscribe(id: string) {
    this.router.navigate(['live-classes', id, 'subscribe']);
  }

  OnClickContinue(id: string) {
    this.router.navigate(['meetings']);
  }

  onClickJoinMeetings(id: string) {
    this.router.navigate(['meetings']);
  }

  onClickAccessResources(id: string) {
    this.router.navigate(['my-learnings', 'live-class', id]);
  }

  // this function is used to check if the user has a valid subscription
  hasValidSubscription(liveClass: LiveClass) {
    const subscription = liveClass.subscriptions;
    return subscription.some((sub) =>
      [
        SubscriptionStatus.ACTIVE,
        SubscriptionStatus.COMPLETE,
        SubscriptionStatus.PENDING,
        SubscriptionStatus.RENEWAL_DUE,
      ].includes(sub.status)
    );
  }

}
